document.addEventListener('DOMContentLoaded', function () {
  const headerMenus = document.querySelectorAll('.header__inline-menu header-menu');

  headerMenus.forEach(menu => {
    let hoverTimeout;
    const details = menu.querySelector('details');
    const menuLink = menu.querySelector('.header__menu-link');

    function openMenu() {
      clearTimeout(hoverTimeout);
      document.querySelectorAll('.header__inline-menu header-menu details[open]').forEach(other => {
        if (other !== details) other.removeAttribute('open');
      });
      details.setAttribute('open', '');
    }

    function scheduleClose() {
      hoverTimeout = setTimeout(() => {
        details.removeAttribute('open');
      }, 600);
    }

    // ✅ Events on DETAILS, not menu
    details.addEventListener('mouseenter', openMenu);
    details.addEventListener('mouseleave', scheduleClose);

    if (menuLink) {
      menuLink.addEventListener('click', e => e.stopPropagation());
    }
  });
});